module.exports = require("vue-drag-resize");